import { QNumberEdit } from "../CoreApp/QNumberEdit";
import { AddTextEdit } from "./AddTextEdit";

export function AddStdIntEdit(
  panel,
  xPos,
  yPos,
  width,
  height,
  blankMsg,
  maxLen,
  tabID,
  addBorder
) {
  var te = new QNumberEdit();
  te.InitTextEdit();
  te.SetIntegerOnly(true);

  AddTextEdit(te, panel, xPos, yPos, width, height, blankMsg, maxLen, tabID, addBorder);
  return te;
}
